import { KeyValueEnum } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { AxiosResponse } from "axios";

export abstract class IEntityTypeApi {
	abstract getDomain(): Promise<AxiosResponse<Result<KeyValueEnum[]>>>;
}
